import { AxiosStatic } from "axios";
import { toCamel, toSnake } from "snake-camel";

export interface Supplier {
  id?: number;
  name: string;
  hansaCode: string | null;
  vatNumber: string | null;
  /** One line, whichever way this supplier is reached. Free text. */
  contact: string | null;
  updatedAt?: string;
}

export interface SupplierFilters {
  search?: string | null;
}

export default ($axios: AxiosStatic) => ({
  async list(filters: SupplierFilters = {}): Promise<Supplier[]> {
    const response = (
      await $axios.get("/api/suppliers", { params: toSnake(filters) })
    ).data.data;
    return response.map((row: any) => toCamel(row) as Supplier);
  },

  async create(data: Supplier): Promise<Supplier> {
    const response = (await $axios.post("/api/suppliers", toSnake(data))).data
      .data;
    return toCamel(response) as Supplier;
  },

  async update(id: number, data: Supplier): Promise<Supplier> {
    const response = (await $axios.put(`/api/suppliers/${id}`, toSnake(data)))
      .data.data;
    return toCamel(response) as Supplier;
  },

  async remove(id: number): Promise<void> {
    await $axios.delete(`/api/suppliers/${id}`);
  }
});
